import { WHATSAPP_QUICK_REPLY_TEMPLATE_PREFIX } from 'cpool-constants';

export const isWhatsAppQuickReplyTemplateName = (templateName: string): boolean =>
    templateName.startsWith(WHATSAPP_QUICK_REPLY_TEMPLATE_PREFIX);
